module.exports = __webpack_public_path__ + "img/syukyaku-top-ira006.7bd3d141.png";